<template>
  <BaseTemplate :currentUser="currentUser">
    <div class="complete-buy-point">
      <Title v-if="pointEndResult && isImmediate" class="_title" eng="BUY POINTS" jpn="Gems purchase completed" />
      <Title v-if="pointEndResult && !isImmediate" class="_title" eng="BUY POINTS" jpn="Gems purchase failure" />
      <div class="area_box">
        <div class="flex-box">
          <div v-if="pointEndResult && isImmediate" class="text thanks immediate">
            <span>Thank you very much.</span>
            <span>We hope you continue to enjoy purchasing our products.</span>
          </div>
          <div v-if="pointEndResult && !isImmediate" class="text thanks delay">
            <span>Amazon Pay payment failed</span>
            <span>Please use other payment methods</span>
          </div>
        </div>
      </div>
      <BlackGradationButton
        class="square-button top"
        text="Go to Top"
        @handleSquareBtnClick="goToTop"
      />
    </div>
  </BaseTemplate>
</template>

<script>
import { mapGetters } from 'vuex';
import BaseTemplate from '@/components/templates/BaseTemplate.vue';
import BlackGradationButton from '@/components/atoms/BlackGradationButton.vue';
import Title from '@/components/molecules/Title.vue';

export default {
  name: 'CompleteBuyPoint',

  beforeRouteLeave(to, from, next) {
    if (to.name === 'PayRedirect') {
      next(false);
    } else {
      next();
    }
  },

  components: {
    BaseTemplate,
    BlackGradationButton,
    Title,
  },

  computed: {
    ...mapGetters({
      currentUser: 'user/currentUser',
      currentPack: 'pack/currentPack',
      pointAppendResult: 'user/pointAppendResult',
      pointEndResult: 'user/pointEndResult',
    }),
    isExistPackId() {
      if (this.pointEndResult) {
        const isExistPackId = this.pointEndResult.pack_id;
        const isNotUndefined = !(typeof this.pointEndResult.pack_id === 'undefined');
        return isExistPackId && isNotUndefined;
      }
      return null;
    },
    isMoreThanPackPoint() {
      if (this.currentPack && this.currentUser) {
        return parseInt(this.currentUser.point, 10) > parseInt(this.currentPack.point, 10);
      }
      return false;
    },
    isImmediate() {
      if (this.pointEndResult) {
        return this.pointEndResult.result === '1';
      }
      return false;
    },
  },

  watch: {
    pointEndResult(newVal) {
      if (newVal) {
        this.$store.dispatch('user/setCurrentUser');
        if (newVal.pack_id) {
          this.$store.dispatch('pack/setCurrentPack', { packId: newVal.pack_id });
        }
      }
    },
  },

  created() {
    this.$store.dispatch('user/setPointEndResult');
  },

  methods: {
    goToTop() {
      this.$router.push('/');
    },
    goToBuyProduct() {
      const query = {
        packId: this.pointAppendResult.pack_id,
      };
      this.$router.push({ path: '/buy-product', query });
    },
  },
};
</script>

<style lang="scss" scoped>
.flex-box {
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.area_box {
  max-width: 680px;
  margin-left: auto;
  margin-right: auto;
}
.complete-buy-point{
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 1000px;
  min-height: 100%;
  padding-top: 0px;
  margin: 0px auto;
  text-align: center;
  @include appendMap($backgroundStyleMap);
  .text.thanks{
    display: flex;
    flex-direction: column;
    align-items: center;
    font-family: $notoSans;
    font-size: 18px;
    line-height: 32.4px;
    color: $white;
  }
  .button-area{
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 60px;
    .square-button{
      width: 120px;
      height: 50px;
      & + .square-button{
        margin-left: 30px;
      }
    }
  }
  .square-button.top{
    width: 200px;
    height: 50px;
    margin: 40px auto 30px;
  }
  ._title {
    margin-top: 30px;
  }
}
@media screen and  (max-width: $tabletWidth) {
  .leaf_box {
    margin: 0 10px;
  }
}
</style>
